"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var VulnerableCustomerAdditionalSupportRecord = /** @class */ (function () {
    function VulnerableCustomerAdditionalSupportRecord() {
    }
    return VulnerableCustomerAdditionalSupportRecord;
}());
exports.default = VulnerableCustomerAdditionalSupportRecord;
//# sourceMappingURL=VulnerableCustomerAdditionalSupportRecord.js.map